<template>
  <div class="gdialogs-container">
    <GDialog v-for="(item, index) in dialogs" :item="item" :key="'dialog_' + index" @close="closeDialog" />
  </div>
</template>

<script>
import { mutations } from '@/store/common/types'
import { mapMutations, mapState } from 'vuex'
import GDialog from './GDialog.vue'
export default {
  components: { GDialog },
  computed: {
    ...mapState("common", {
      dialogs: state => state.messages,
    })
  },
  methods: {
    ...mapMutations("common", {
      closeGDialog: mutations.COMMON_CLOSE_GDIALOG,
    }),
    closeDialog(id) {
      this.closeGDialog(id);
    }
  }
}
</script>

<style>

</style>
